import { supabase } from "@/lib/supabase";

export interface Promotion {
  id: number;
  title: string | null;
  subtitle: string | null;
  image_url: string | null;
  cta_text: string | null;
  cta_link: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export const PROMO_DISMISS_KEY = "vendeya:promo:dismissed";

/**
 * Obtiene la promoción activa más reciente (para el anuncio fullscreen).
 */
export async function fetchActivePromotion(): Promise<Promotion | null> {
  try {
    const { data, error } = await supabase
      .from("promotions")
      .select("*")
      .eq("active", true)
      .order("updated_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    if (error) return null;
    return (data as Promotion) ?? null;
  } catch {
    return null;
  }
}